import { InfoSet } from "../InfoSets/InfoSet";
import { Dictionary } from "../Utils/Dictionary";
import { Device } from "../Core/Device";
import { ArpEntry, ArpTable } from "../Core/ArpTable";
import { MacAddress } from "../Core/MacAddress";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { HashSet } from "../Utils/HashSet";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//import ArpEntryJsonWrapper = DiscoveryEngine.ArpEntryJsonWrapper;

export class IfArpTable extends InfoSet
{
    //public static FromJson(json: InfoSetEntriesJson<ArpEntryJsonWrapper>, device: Device): IfArpTable {
    //    var result = new IfArpTable(device);

    //    json.entries.forEach((jsonEntry) => {
    //        var entry = ArpEntry.FromJson(jsonEntry.arp_entry);

    //        if (result._ifArpTable.ContainsKey(entry.IfIndex)) {
    //            var arpTable = result._ifArpTable.Item(entry.IfIndex);
    //            arpTable.Add(entry);
    //        }
    //        else {
    //            var arpTable = new ArpTable();

    //            arpTable.Add(entry);
    //            result._ifArpTable.Add(entry.IfIndex, arpTable);
    //        }
    //    });

    //    return result;
    //}

	private _ifArpTable: Dictionary<number, ArpTable> ;

	constructor(device: Device) {
		super(device);
		this._ifArpTable = new Dictionary<number, ArpTable>();
	}

	public Add(arpEntry:ArpEntry): void {
		if (arpEntry.IfIndex >= 0) {
			var arpTable: ArpTable = this._ifArpTable.Item(arpEntry.IfIndex);

			if (!arpTable) {
				arpTable = new ArpTable();
				this._ifArpTable.Add(arpEntry.IfIndex, arpTable);
			}

			arpTable.Add(arpEntry);
		}
	}

	public Clear(): void {
		this._ifArpTable.Clear();
	}

	public get Count(): number {
		return (this._ifArpTable.Count);
	}

	public get HasIpSightings(): boolean {
		return true;
	}

	public get IpSightings(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		this._ifArpTable.ForEach((pair) => {
			pair.Value.ForEach((arpEntry) => {
				if (arpEntry.IpAddress == null)
					return;
				if (!arpEntry.IpAddress.IsValidDiscoveryAddress)
					return;
				ipAddresses.Add(arpEntry.IpAddress);
			});
		});

		return (ipAddresses);
	}

	public get HasMacSightings():boolean {
		return true;
	}

	public get MacSightings(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		this._ifArpTable.ForEach((pair) => {
			pair.Value.ForEach((arpEntry) => {
				if (!arpEntry.HasMacAddress)
					return;
				macAddresses.Add(arpEntry.MacAddress);
			});
		});

		return (macAddresses);
	}

	public ForEach(callbackfn: (value: ArpTable, index: number, array: ArpTable[]) => void, thisArg?: any): void {
		this._ifArpTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: ArpTable, index: number, array: ArpTable[]) => boolean, thisArg?: any): boolean {
		return this._ifArpTable.Values().Some(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.if_arp_info = {};
		obj = obj.if_arp_info;

		obj.entries = [];
		this._ifArpTable.Values().ForEach((arpTable: ArpTable) => {
			arpTable.ForEach((arpEntry: ArpEntry) => {
				let elem: any = {
					arp_entry: {
						if_index: ValueEncoder.EncodeInteger(arpEntry.IfIndex),
						ip_address: ValueEncoder.EncodeIpAddress(arpEntry.IpAddress)
					}
				};

				if (arpEntry.HasMacAddress) {
					elem.arp_entry.mac_address = ValueEncoder.EncodeMacAddress(arpEntry.MacAddress);
				}

				if (arpEntry.HasType) {
					elem.arp_entry.type = ValueEncoder.EncodeInteger(arpEntry.Type);
				}

				if (arpEntry.HasState) {
					elem.arp_entry.state = ValueEncoder.EncodeInteger(arpEntry.State);
				}

				obj.entries.push(elem);
			}, this);
		}, this);
	}

	public Read(obj: any, context: any): void {
		if (!obj.if_arp_info)
			throw new Error();
		obj = obj.if_arp_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((elem: any) => {
				if (!elem.arp_entry)
					throw new Error();
				elem = elem.arp_entry;

				let arpEntry = new ArpEntry();

				if (elem.if_index !== undefined) {
					arpEntry.IfIndex = ValueEncoder.DecodeInteger(elem.if_index);
				}

				if (elem.ip_address !== undefined) {
					arpEntry.IpAddress = ValueEncoder.DecodeIpAddress(elem.ip_address);
				}

				if (elem.mac_address !== undefined) {
					arpEntry.MacAddress = ValueEncoder.DecodeMacAddress(elem.mac_address);
				}

				if (elem.type !== undefined) {
					arpEntry.Type = ValueEncoder.DecodeInteger(elem.type);
				}

				if (elem.state !== undefined) {
					arpEntry.State = ValueEncoder.DecodeInteger(elem.state);
				}

				this.Add(arpEntry);
			}, this);
		}
	}
}
